import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Edit3, Eye, Trash2, User } from 'react-feather';
import IconButton from '@mui/material/IconButton';
import '../../styles/table.css'; // Importing the external CSS
import Grid from '@mui/material/Grid2';
import { PlusCircle } from 'react-feather';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Toastmessage from '../../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../../api/api';
import { useSelector } from 'react-redux';
import { logout } from '../../features/auth/AuthSlice';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';


export default function LocationTable({ apiResponse }) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]); // Store filtered data
  const [searchText, setSearchText] = useState('');
  const [open, setOpen] = useState(false);
  const [deleteDesignation, setDeletedesingation] = useState('');

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch()
  const navigate = useNavigate();

  useEffect(() => {
    fetchDesignation();
  }, [token, userID]); // Run effect when token or userID changes

  // Define fetchDesignation separately to reuse it
  const fetchDesignation = async () => {
    const input_token = 'DESIGNATION'; // Replace with your actual token
    const apiUrl = 'list_of_designation'; // Replace with the actual API endpoint

    const dataInput = {
      login_user_id: userID
    };

    try {
      const data = await authApi(input_token, dataInput, apiUrl, token);

      if (data && data.success) {
        setRows(data.designations);
        setFilteredRows(data.designations); // Set filtered rows to the same data initially
      } else if (data && data.message === 'Token has expired') {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else if (data === undefined) {
        await Toastmessage('No response from server', false);
      } else {
        await Toastmessage(data?.message || 'An error occurred', false);
      }

    } catch (error) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        localStorage.removeItem('token');
        await Toastmessage('Session expired. Redirecting to login...', false);
        navigate('/login');
      } else {
        await Toastmessage('Something went wrong', false);
      }
    }
  };

  const handleClickEdit = (id) => {
    navigate('/editdesignation', { state: { designationId: id } });
  };

  const handleClickView = (id) => {
    navigate('/viewdesignation', { state: { designationId: id } });
  };

  const columns = [
    {
      field: 'designation_name',
      headerName: 'Designation Name',
      flex: 1
    },
    { field: 'no_of_enrolled', headerName: 'Enrolled', flex: 1, },
  
    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      renderCell: (params) => {
        return (
          <div>
            {params.row.status == 1 ? 'Active' : 'Inctive'}
          </div>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params) => (
        <>
        {apiResponse?.data?.actions?.view && (
          <IconButton
            onClick={() => handleClickView(`${params.row.id}`)}
            sx={{
              backgroundColor: 'var(--action-icon-bg)',
              color: 'var(--action-icon-color)',
              borderRadius: '50%',
              padding: '8px', // Reduce padding size
              marginRight: '8px',
            }}
            size="small" // Decrease the button size
          >
            <Eye size={16} /> {/* Smaller Feather icon size */}
          </IconButton>
        )}
        {apiResponse?.data?.actions?.edit && (
          <IconButton
            onClick={() => handleClickEdit(`${params.row.id}`)}
            sx={{
              backgroundColor: 'var(--action-icon-bg)',
              color: 'var(--action-icon-color)',
              borderRadius: '50%',
              padding: '8px',
              marginRight: '8px',
            }}
            size="small"
          >
            <Edit3 size={16} />
          </IconButton>
        )}
        {apiResponse?.data?.actions?.delete && (
          <IconButton
            onClick={() => handleClickOpen(params.row.id)}
            sx={{
              backgroundColor: 'var(--action-icon-bg)',
              color: 'var(--action-icon-color)',
              borderRadius: '50%',
              padding: '8px',
            }}
            size="small"
          >
            <Trash2 size={16} />
          </IconButton>
          )}
        </>  
      ),
    },
  ];


  const handleDelete = async () => {


    const fetchData = async () => {
      const input_token = deleteDesignation + 'DELETE';; // Replace with your actual token
      const apiUrl = 'delete_designation'; // Replace with the actual API endpoint

      const dataInput = {
        designation_id: deleteDesignation,
        login_user_id: userID
      };
      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setOpen(false);
          await fetchDesignation(); // Refresh the list after deletion
        } else if (data && data.message === 'Token has expired') {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          await Toastmessage('No response from server', false);
        } else {
          await Toastmessage(data?.message || 'An error occurred', false);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    }

    // Call the function to make the API call
    await fetchData();
  };

  const handleClickOpen = (id) => {
    setOpen(true);
    setDeletedesingation(id);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchText(value);

    // Search all fields in rows
    const filteredData = rows.filter((row) =>
      Object.values(row).some((field) =>
        String(field).toLowerCase().includes(value)
      )
    );
    setFilteredRows(filteredData); // Update filtered rows
  };

  const clearSearch = () => {
    setSearchText('');
    setFilteredRows(rows); // Reset to original data
  };

  return (

    <Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
        className="title_head"
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="var(--text-color)">
             Designation List
          </Typography>
        </Box>

        {/* Right Section */}
        {apiResponse?.data?.actions?.add && (
        <Button
          variant="outlined"
          component={Link}
          to="/adddesignation"
           className='btn-theme-button'
          startIcon={<PlusCircle sx={{ fontSize: 17 }} />}
          style={{ textTransform: 'none' }}
        >
          Add New Designation 
        </Button>
        )}
      </Box>


      <Box className="location-container" m={3}>

        <Box className="location-header ">
          <h2>Total Designation {rows.length}</h2>
          <Box sx={{ position: 'relative', width: '300px' }}> {/* Adjust width as needed */}
            <TextField
              label="Search"
              variant="outlined"
              value={searchText}
              onChange={handleSearch}
              className="search-input"
              fullWidth
              InputProps={{
                endAdornment: searchText && (
                  <span
                    onClick={() => clearSearch()}
                    style={{
                      cursor: 'pointer',
                      color: '#aaa',
                      marginRight: '10px',
                    }}
                  >
                    ✕
                  </span>
                ),
              }}
            />
          </Box>
        </Box>
        <div sx={{ m: 0, p: 0 }}>
          <Box sx={{ width: '100%', display: 'flex' }}>
            <DataGrid
              rows={filteredRows}
              columns={columns}
              pageSize={5}
              autoHeight
              pagination
              disableSelectionOnClick
              rowsPerPageOptions={[]}
              className="data-grid"
              sx={{ width: '100%' }} // Ensure DataGrid takes full width
            />
          </Box>
        </div>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to delete this designation?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Disagree</Button>
            <Button onClick={handleDelete} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </Box>

    </Box>


  );
}
